import React from 'react'
import MyClassesList from '~components/MyClassesList'
import { ClassesStackScreenProps } from '~types'

type Props = ClassesStackScreenProps<'MyClasses'>

export default function MyClassesScreen(props: Props): JSX.Element {
  return <MyClassesList create="none" />
}
